export enum FundTypeId {
  Cash = 1,
  Balanced = 2,
  DiversifiedIncome = 3
}
